export const dict = {
  en: {
    "nav.home": "Home",
    "nav.shop": "Shop",
    "nav.story": "Our Story",
    "nav.active": "Active Living",
    "nav.support": "Support",

    "hero.kicker": "FOR A MORE ACTIVE TOMORROW",
    "hero.line1": "MOVE",
    "hero.line2": "WITH",
    "hero.line3": "CARE.",
    "hero.copy1": "Every step, every day.",
    "hero.copy2": "PaMak stays close to the people you love.",
    "hero.shop": "SHOP NOW",
    "hero.discover": "DISCOVER PAMAK",
    "hero.note1": "Active",
    "hero.note2": "Together",
    "hero.note3": "ដើម្បីខ្លួនឯងនិងមនុស្សជាទីស្រលាញ់",

    "products.eyebrow": "OUR PRODUCTS",
    "products.title1": "MADE TO",
    "products.title2": "MOVE WITH YOU.",
    "products.desc": "Simple support products for everyday life. Designed for comfort, movement and the people you care about.",
    "products.viewAll": "VIEW ALL PRODUCTS",
    "products.loading": "Loading products…",
    "products.empty": "Products are coming soon.",
    "product.add": "Add to bag",
    "product.knee": "Knee Support",
    "product.bag": "Running Waist Bag",

    "feature.eyebrow": "KNEE SUPPORT",
    "feature.title1": "SUPPORT",
    "feature.title2": "THAT *MOVES*",
    "feature.title3": "WITH *YOU.*",
    "feature.desc": "Made for daily activities, walking, light exercise and the everyday moments that matter.",
    "feature.shop": "SHOP NOW",
    "feature.learn": "LEARN MORE",
    "callout.fit": "Adjustable fit",
    "callout.breathable": "Breathable",
    "callout.light": "Lightweight",
    "callout.support": "Everyday support",
    "callout.comfort": "Comfortable design",
    "callout.wear": "Easy to wear",

    "story.eyebrow": "OUR STORY",
    "story.title1": "FOR THE PEOPLE",
    "story.title2": "WHO KEEP US",
    "story.title3": "*MOVING.*",
    "story.desc": "From daily walks to active weekends, PaMak creates simple support products for everyday life.",
    "story.btn": "OUR STORY",

    "cat.knee": "Knee Support",
    "cat.kneeSub": "Stay active with confidence.",
    "cat.carry": "Everyday Carry",
    "cat.carrySub": "Bring your essentials freely.",
    "cat.essentials": "Active Essentials",
    "cat.essentialsSub": "Light, simple and practical.",
    "cat.soon": "Coming Soon",
    "cat.soonSub": "More care products on the way.",

    "benefit.delivery": "Cambodia Delivery",
    "benefit.deliverySub": "Fast and reliable.",
    "benefit.payment": "Secure Payment",
    "benefit.paymentSub": "ABA / KHQR ready.",
    "benefit.support": "Customer Support",
    "benefit.supportSub": "We're here to help.",
    "benefit.offers": "Special Offers",
    "benefit.offersSub": "Member rewards & promotions.",

    "home.eyebrow": "OUR HOME",
    "home.title1": "BORN IN",
    "home.title2": "CAMBODIA.",
    "home.desc": "Modern everyday support, inspired by the people and energy of Cambodia.",

    "member.eyebrow": "MEMBERSHIP",
    "member.title": "JOIN THE PAMAK CIRCLE.",
    "member.desc": "Be the first to hear about new products, offers and active-living stories.",
    "member.placeholder": "Phone number or email",
    "member.join": "JOIN",

    "cart.eyebrow": "YOUR BAG",
    "cart.title": "Shopping Bag",
    "cart.empty": "Your shopping bag is empty.",
    "cart.empty2": "Start moving with PaMak.",
    "cart.subtotal": "Subtotal",
    "cart.delivery": "Delivery",
    "cart.calc": "Calculated at checkout",
    "cart.free": "FREE",
    "product.set": "Parent Set",
    "set.badge": "FREE 2 STRAPS",
    "set.includes": "2 free adjustable straps + PaMak Pin included",
    "cat.set": "Parent Set",
    "cat.setSub": "Everything for active parents.",
    "search.placeholder": "Search products…",
    "story.page.eyebrow": "THE STORY BEHIND PAMAK",
    "story.page.heroTitle": "Two Students. One Dream. A Little Love That Started It All.",
    "story.page.heroLine": "Every meaningful journey begins somewhere. Ours began with family.",
    "story.page.timeline": "Our Journey Timeline",
    "story.page.chapterNav": "Jump to a chapter",
    "story.page.withLove": "With love,",
    "story.page.coFounders": "Co-founders of PaMak",
    "story.page.sloganLine": "From Our Generation, With Love for Every Generation.",
    "story.page.slogan": "ONE ACT OF LOVE, A WAVE OF CARE.",
    "story.page.explore": "Explore Our Products",
    "story.page.share": "Share Our Story",
"shop.catAll": "All",
    "shop.catAddons": "Add-ons",
    "details.pin.about": "The official PaMak pin — a small touch of the brand you can carry anywhere.",
    "details.pin.features": "Official PaMak design|Compact and lightweight|Easy to attach",
    "details.pin.use": "Attach it to your shirt, bag or cap.",
    "details.strap.about": "A pair of PaMak adjustable straps for fine-tuning the fit of your knee support.",
    "details.strap.features": "One pair included|Adjustable length|Easy to clean",
    "details.strap.use": "Use them to adjust how your PaMak knee support fits.",
    "search.none": "No products match your search.",
    "auth.login": "LOG IN",
    "auth.register": "REGISTER",
    "auth.name": "Full Name",
    "auth.email": "Email",
    "auth.phone": "Phone Number",
    "auth.password": "Password",
    "auth.logout": "Log out",
    "auth.myOrders": "My Orders",
    "auth.ownerPanel": "Owner Panel",
    "auth.points": "points",
    "auth.earn": "Earn 1 point for every $1 spent.",
    "auth.guestNote": "Checking out as guest — log in to earn points",
    "auth.welcome": "Welcome back",
    "auth.created": "Account created. Welcome to PaMak!",
    "auth.needLogin": "Please log in to see your orders.",
    "auth.ownerNeedLogin": "Owner login required to view orders.",
    "confirm.title": "ORDER PLACED!",
    "confirm.thanks": "Thank you — your order is in.",
    "confirm.id": "Your Order Code",
    "confirm.remark": "Use this code as your ABA payment Remark.",
    "confirm.copiedCheck": "I have copied my Order Code",
    "confirm.paynow": "CONTINUE TO ABA PAYWAY",
    "confirm.otherNote": "You chose another payment method. Our team will contact you to arrange payment — nothing is charged through this website.",
    "checkout.paywayTitle": "Pay with ABA PayWay",
    "checkout.paywayNote": "For ABA users",
    "checkout.bakongTitle": "Pay with Bakong",
    "checkout.bakongNote": "For ABA and supported banking apps",
    "confirm.orderCodeLabel": "Order Code:",
    "confirm.amountLabel": "Amount:",
    "confirm.paywayHint": "Pay securely in the ABA app, then come back and press the green button below.",
    "confirm.remarkLabel": "Remark",
    "confirm.qrBanksNote": "Works with ABA and supported banking apps.",
    "confirm.completedPayment": "I HAVE COMPLETED PAYMENT",
    "confirm.completedHint": "Press only after you have paid — PaMak will verify your payment shortly.",
    "confirm.submittedOk": "Status updated — thank you!",
    "confirm.submittedMsg": "Your payment is awaiting verification by the PaMak team. If you have already paid, please don't worry — we will update your status after verification.",
    "confirm.refPlaceholder": "ABA transaction / reference number (optional)",
    "confirm.receiptLabel": "Upload payment receipt (optional)",
    "confirm.receiptTooBig": "Image is too large — please use a file under 5MB.",
    "confirm.sendInfo": "SEND TO PAMAK",
    "confirm.sentOk": "Received — we will verify your payment shortly.",
    "auth.changePassword": "Change Password",
    "auth.currentPassword": "Current Password",
    "auth.newPassword": "New Password",
    "auth.pwChanged": "Password changed ✓",
    "auth.pwMismatch": "Current password is incorrect.",
    "auth.unavailable": "Your account is currently unavailable. Please contact PaMak for assistance.",
    "member.level.member": "Member",
    "member.level.silver": "Silver member",
    "member.level.gold": "Gold member",
    "owner.dashboard": "Owner Dashboard",
    "owner.ordersTab": "Orders & Payments",
    "owner.usersTab": "User Management",
    "owner.activityTab": "Activity Log",
    "owner.payway": "ABA PayWay",
    "owner.payQr": "ABA QR",
    "owner.paymentRef": "Transaction / Reference",
    "owner.receipt": "Receipt",
    "owner.viewReceipt": "View receipt",
    "owner.noReceipt": "No receipt uploaded.",
    "owner.confirmPayTitle": "Confirm payment?",
    "owner.confirmPayBody": "Verify the ABA payment for {code} before confirming. The customer's order will update everywhere and Telegram will be notified.",
    "owner.cancel": "Cancel",
    "owner.confirmedRevenue": "confirmed revenue",
    "owner.updated": "Updated ✓",
    "owner.searchUsers": "Search by name, email, phone or ID…",
    "owner.searchBtn": "SEARCH",
    "owner.noUsers": "No customer accounts found.",
    "owner.userId": "User ID",
    "owner.registered": "Registered",
    "owner.lastLogin": "Last login",
    "owner.totalSpent": "Total spent",
    "owner.ordersCount": "orders",
    "owner.saveProfile": "Save",
    "owner.suspend": "Suspend account",
    "owner.disable": "Disable account",
    "owner.reEnable": "Re-enable account",
    "owner.resetPwd": "Trigger password reset",
    "owner.orderHistory": "Order history",
    "owner.uStatus.active": "Active",
    "owner.uStatus.suspended": "Suspended",
    "owner.uStatus.disabled": "Disabled",
    "owner.confirmSuspendTitle": "Suspend this account?",
    "owner.confirmDisableTitle": "Disable this account?",
    "owner.confirmReenableTitle": "Re-enable this account?",
    "owner.confirmBody": "Are you sure you want to continue for {name}? Their orders, payments and points are preserved.",
    "owner.confirmResetTitle": "Trigger password reset?",
    "owner.confirmResetBody": "A temporary password will be generated for {name}. You must give it to the customer — you can never see their own password.",
    "owner.tempPwTitle": "Temporary password created",
    "owner.tempPwBody": "One-time temporary password for {name}:",
    "owner.tempPwNote": "Give this to the customer and ask them to log in and change it. You will not see it again.",
    "owner.done": "DONE",
    "owner.byAdmin": "by",
    "owner.noActivity": "No activity yet.",
    "name.knee": "PaMak Knee Support",
    "name.bag": "PaMak Running Waist Bag",
    "name.set": "PaMak Parent Set",
    "product.whyTitle": "WHY YOU'LL LIKE IT",
    "product.viewDetails": "View Product Details",
    "product.hideDetails": "Hide Details",
    "product.about": "About this product",
    "product.features": "Key Features",
    "product.use": "Suggested Use",
    "product.inStock": "In Stock",
    "product.soldOut": "Sold Out",
    "product.onlyLeft": "Only {n} left",
    "benefits.knee": "Comfortable everyday knee support|Adjustable fit with secure fastening|Lightweight and breathable design|Suitable for walking, running and everyday activities",
    "benefits.bag": "Lightweight design for active days|Multiple compartments for daily essentials|Adjustable waist fit|Reflective detail for better visibility",
    "details.knee.about": "Designed for movement and everyday comfort, the PaMak Knee Support provides gentle compression and support around the knee while allowing you to stay active.|Its contoured shape is designed to sit comfortably around the knee, while the soft cushioning areas help provide a more comfortable feel during movement.|The adjustable strap allows you to find a secure fit according to your comfort level.|The lightweight and breathable construction makes it suitable for everyday wear and activities such as walking, light exercise, running, skipping and other recreational activities.",
    "details.knee.features": "Ergonomic contoured design|Soft cushioning support areas|Adjustable fastening for a more secure fit|Lightweight construction|Breathable design for greater comfort|Flexible enough for everyday movement|Suitable for active and everyday use",
    "details.knee.use": "Wear the support around the knee and adjust the fastening until it feels comfortably secure. It should feel supportive without being excessively tight. This product is designed for general support and comfort during daily activities and exercise.",
    "details.bag.about": "Keep your essentials close without carrying a bulky bag.|The PaMak Running Waist Bag is designed for running, walking, travel and everyday activities.|Its slim, lightweight profile sits close to the body while giving you convenient storage for essentials such as your phone, keys, cards and small personal items.|The multi-pocket design helps keep your belongings separated and easier to organize.|The adjustable waist strap allows the bag to fit a wide range of users and makes it easy to tighten or loosen depending on your preference.",
    "details.bag.features": "Lightweight design — approximately 70 g based on supplier information|Adjustable waist strap|Approximate supported waist range: 55–120 cm based on supplier information|Multi-compartment / 3-pocket design|Suitable for phones up to approximately 7.5 inches based on supplier information|Space for phone, keys, cards, cash and small essentials|Reflective detailing for increased visibility|Flexible, comfortable fabric|Water-resistant material for everyday splashes and sweat|Compact design that stays close to the body|Suitable for running, walking, exercise, travel and everyday use",
    "details.bag.use": "Adjust the strap comfortably around your waist, place your essentials inside the appropriate compartments and securely close the zippers before activity.",
    "stock.liveNote": "Live stock — updates with every order",
    "owner.recheckPayway": "CHECK WITH PAYWAY",
    "owner.paywayStatus": "PayWay status",
    "confirm.qrReady": "Your payment QR is ready",
    "confirm.paywayScanHint": "Scan this code with any banking app — the amount is fixed for this order.",
    "confirm.openAbaApp": "OPEN ABA APP TO PAY",
    "confirm.autoVerifyHint": "After paying, press the green button — PaMak verifies with PayWay automatically.",
    "confirm.sandboxNotice": "TEST MODE (PayWay sandbox): this is a test QR for visual reference only. The real ABA Mobile app cannot pay it and will show \"Transaction not found\". Real payments start once PaMak switches to live PayWay credentials.",
    "confirm.diagTitle": "TEMPORARY DIAGNOSTICS (SANDBOX TESTING)",
    "confirm.diagErrorTitle": "PAYWAY ERROR DIAGNOSTICS (SANDBOX)",
    "confirm.diagEnv": "Environment",
    "confirm.diagTranId": "PayWay transaction ID",
    "confirm.diagStatus": "PayWay status code",
    "confirm.diagMessage": "PayWay message",
    "confirm.diagTrace": "Trace ID",
    "confirm.paywayUnpaid": "PayWay could not confirm this payment yet. Status:",
    "confirm.paywayPaidOk": "Payment confirmed by PayWay — thank you!",
    "auth.confirmPw": "Confirm password",
    "auth.pwMismatch": "Passwords do not match.",
    "auth.forgotLink": "Forgot Password?",
    "auth.codeLabel": "6-digit code",
    "auth.verifyTitle": "VERIFY YOUR EMAIL",
    "auth.verifyDesc": "We sent a 6-digit code to {email}. Enter it below to verify your email.",
    "auth.verifyBtn": "Verify email",
    "auth.resendBtn": "Resend code",
    "auth.resendOk": "A new code is on its way — please check your inbox.",
    "auth.verifiedOk": "Welcome to PaMak! Your email has been verified successfully.",
    "auth.forgotTitle": "FORGOT PASSWORD",
    "auth.forgotDesc": "Enter your email and we'll send you a password reset code.",
    "auth.forgotBtn": "Send reset code",
    "auth.forgotOk": "If an account exists with this email, we've sent password reset instructions.",
    "auth.resetTitle": "RESET PASSWORD",
    "auth.newPw": "New password",
    "auth.resetBtn": "Change password",
    "auth.resetOk": "Your password has been changed successfully. Please sign in with your new password.",
    "auth.backToLogin": "Back to login",
    "auth.verifyNow": "Verify your email",
    "auth.notVerified": "Email not verified",
    "auth.memberBadge": "PaMak Member",
    "auth.done": "Done",
    "member.namePlaceholder": "Full name",
    "member.emailPlaceholder": "Email address",
    "member.agree": "I agree to join the PaMak Membership Program and agree to PaMak's",
    "member.termsLink": "Terms & Membership Agreement",
    "member.privacyLink": "Privacy Policy",
    "member.marketing": "I would like to receive PaMak news, new product announcements, member benefits, promotions and special offers by email.",
    "member.agreeRequired": "Please accept the membership agreement to join the PaMak Circle.",
    "member.alreadyAccount": "You're already a PaMak member. Please sign in to view your membership.",
    "member.alreadyMember": "You're already a PaMak member.",
    "member.termsTitle": "Terms & Membership Agreement",
    "member.termsBody": "Joining the PaMak Circle is free. Members collect PaMak Points on completed orders and may receive member benefits as they launch. Points have no cash value and cannot be exchanged or redeemed yet. PaMak may update these terms; the current version is always shown here. You may stop being a member at any time by contacting PaMak.",
    "member.privacyTitle": "Privacy Policy",
    "member.privacyBody": "PaMak stores your name, email and membership status to run the membership program. Your agreement and marketing choices are stored separately, with the date you gave them. Marketing emails are only sent if you opt in, and every marketing email includes an unsubscribe link. We never sell your data. Passwords are stored securely (hashed) and can never be read by PaMak staff.",
    "mpage.title": "PaMak Membership",
    "mpage.statusLabel": "Member status",
    "mpage.statusActive": "Active Member",
    "mpage.statusNone": "Not a member yet",
    "mpage.pointsLabel": "Total Points",
    "mpage.sinceLabel": "Member Since",
    "mpage.idLabel": "Member ID",
    "mpage.badge": "PaMak Member",
    "mpage.rewardsTitle": "PaMak Rewards — Coming Soon",
    "mpage.rewardsDesc": "Your PaMak Points will soon unlock special rewards, member benefits and discounts. Keep collecting — more is coming soon.",
    "mpage.joinCta": "Join the PaMak Circle",
    "mpage.loginNeeded": "Sign in to see your membership.",
    "owner.membersTab": "Members",
    "owner.mTotal": "Total Members",
    "owner.mNew": "New Members",
    "owner.mVerified": "Verified Members",
    "owner.mMarketing": "Marketing Subscribers",
    "owner.mSearch": "Search name, email or member ID",
    "owner.mMarketingAll": "All consent statuses",
    "owner.mMarketingYes": "Marketing: yes",
    "owner.mMarketingNo": "Marketing: no",
    "owner.mJoined": "Joined",
    "owner.mVerifiedY": "Verified",
    "owner.mVerifiedN": "Not verified",
    "owner.mLastOrder": "Last order",
    "owner.mOrders": "Orders",
    "owner.mSpent": "Total spent",
    "owner.mLifetime": "Lifetime points",
    "owner.mNoMembers": "No PaMak members yet.",
    "owner.mNoMatch": "No members match this filter.",
    "checkout.promoLabel": "Promo Code",
    "checkout.promoPlaceholder": "Enter promo code",
    "checkout.promoApply": "APPLY",
    "checkout.promoRemove": "Remove",
    "checkout.promoApplied": "Promo code applied successfully!",
    "checkout.youSaved": "You saved",
    "checkout.promoInvalid": "This promo code is invalid, expired, inactive, or does not apply to this order.",
    "checkout.promoLine": "Promo:",
    "confirm.earnedAfter": "Points you'll earn after payment:",
    "confirm.outOfStockTitle": "OUT OF STOCK",
    "confirm.outOfStock": "Your payment went through, but this item just sold out. PaMak will contact you to arrange a refund or another colour.",
    "member.pitch": "Be the first to discover new products, member benefits and special PaMak offers.",
    "member.joinBtn": "JOIN",
    "member.modalJoinBtn": "JOIN PAMAK CIRCLE",
    "owner.pActive": "Active (code is usable)",
    "member.modalTitle": "Join the PaMak Circle",
    "member.modalWelcome": "Become part of the PaMak community and stay connected with what's coming next.",
    "member.agreeComms": "I would like to join the PaMak Membership Program and receive important membership-related communications from PaMak.",
    "member.successTitle": "Welcome to the PaMak Circle 🌸",
    "member.successDesc": "Please check your email to complete your membership.",
    "member.successToast": "Welcome to the PaMak Circle 🌸 Please check your email to complete your membership.",
    "member.welcomeActive": "Welcome to the PaMak Circle 🌸 Your membership is now active.",
    "member.verifyHere": "Enter the 6-digit code from your email to finish right now:",
    "member.verifyBtn": "Verify & activate",
    "member.alreadyCircle": "You're already part of the PaMak Circle. Sign in to view your membership and points.",
    "mpage.statusPending": "Pending verification",
    "mpage.pendingNote": "One last step: verify your email to activate your membership. Check your inbox for the code.",
    "owner.promosTab": "Promo Codes",
    "owner.pNew": "New Promo Code",
    "owner.pCode": "Promo code",
    "owner.pCampaign": "Campaign name",
    "owner.pType": "Discount type",
    "owner.pPercent": "Percentage",
    "owner.pFixed": "Fixed amount",
    "owner.pValue": "Discount value",
    "owner.pMaxDiscount": "Maximum discount (percent promos)",
    "owner.pMaxShort": "cap",
    "owner.pMinOrder": "Minimum order amount",
    "owner.pStart": "Start date & time",
    "owner.pEnd": "End date & time",
    "owner.pUsageLimit": "Total usage limit (blank = unlimited)",
    "owner.pPerCustomer": "Usage limit per customer (blank = unlimited)",
    "owner.pRequiresLogin": "Customer must be logged in",
    "owner.pMembersOnly": "PaMak members only",
    "owner.pProducts": "Eligible products (blank = all products)",
    "owner.pCategory": "Eligible category (blank = all)",
    "owner.pExcluded": "Excluded products",
    "owner.pAppliesTo": "Applies to",
    "owner.pProductsOnly": "Products only",
    "owner.pShipping": "Delivery / shipping",
    "owner.pDescription": "Campaign notes",
    "owner.pSave": "Save promo code",
    "owner.pEdit": "Edit",
    "owner.pDuplicate": "Duplicate",
    "owner.pDisable": "Disable",
    "owner.pEnable": "Enable",
    "owner.pDelete": "Delete",
    "owner.pUsed": "Used",
    "owner.pRemaining": "Remaining",
    "owner.pDiscountGiven": "Discount given",
    "owner.pSales": "Sales generated",
    "owner.pOrders": "Paid orders",
    "owner.pSearch": "Search promo codes",
    "owner.pUnlimited": "unlimited",
    "owner.pFilterAll": "All statuses",
    "owner.pFilterActive": "Active",
    "owner.pFilterScheduled": "Scheduled",
    "owner.pFilterExpired": "Expired",
    "owner.pFilterDisabled": "Disabled",
    "owner.pFilterExhausted": "Limit reached",
    "owner.pNoPromos": "No promo codes yet.",
    "owner.pDeleteBlocked": "Used promos cannot be deleted — disable instead.",
    "confirm.payNowCta": "GET MY PAYMENT QR",
    "auth.membership": "Membership / Rewards",
    "owner.stockTab": "Stock",
    "owner.stockHint": "Set how many pieces you have for each product. Cards and bags show it live.",
    "confirm.track": "Track My Order",
    "confirm.earned": "You earned",
    "confirm.copy": "COPY ORDER CODE",
    "toast.copied": "Copied ✓",
    "toast.bye": "Logged out. See you soon!",
    "toast.blog": "Blog coming soon",
    "addon.add": "Add",
    "opt.knee": "Knee Support",
    "opt.bag": "Wrist Bag",
    "opt.kneeShort": "Knee",
    "opt.bagShort": "Wrist Bag",
    "cart.color": "Color",
    "track.title": "Track Order",
    "track.placeholder": "Order Code, e.g. PMK-A7K29",
    "track.button": "TRACK",
    "track.notFound": "Order not found — please check your Order Code.",
    "track.phoneMatch": "Phone number does not match this order.",
    "track.phonePlaceholder": "Phone used at checkout",
    "track.awaiting": "Payment is pending — PaMak confirms your ABA payment shortly after you pay. Nothing is charged through this website.",
    "track.hint": "Every PaMak order has a unique code like PMK-A7K29. Track with the code + the phone number used at checkout.",
    "track.items": "Items",
    "track.payment": "Payment",
    "track.step.received": "Order Received",
    "track.step.pending": "Payment Pending",
    "track.step.confirmed": "Payment Confirmed",
    "track.step.preparing": "Preparing Order",
    "track.step.shipped": "Shipped",
    "track.step.out": "Out for Delivery",
    "track.step.delivered": "Delivered",
    "faq.title": "PaMak Assist",
    "faq.placeholder": "Ask about products, delivery, payment…",
    "faq.hello": "Hi! I can help with products, delivery, payments, tracking and more.",
    "footer.track": "Track Order",
    "orders.title": "My Orders",
    "orders.empty": "No orders yet — your first order is waiting!",
    "status.received": "New Order",
    "status.processing": "Processing",
    "status.preparing": "Preparing",
    "status.ready_for_delivery": "Ready for Delivery",
    "status.shipped": "Shipped / Delivering",
    "status.out_for_delivery": "Out for delivery",
    "status.delivered": "Completed",
    "status.cancelled": "Cancelled",
    "owner.confirmPay": "CONFIRM PAYMENT",
    "owner.flowProcess": "START PROCESSING",
    "owner.flowPrepare": "START PREPARING",
    "owner.flowReady": "MARK READY FOR DELIVERY",
    "owner.flowShip": "MARK SHIPPED",
    "owner.flowComplete": "MARK COMPLETED",
    "cart.total": "Total",
    "cart.checkout": "CHECKOUT",

    "payment.pending": "Awaiting Payment",
    "payment.submitted": "Payment Submitted — Waiting for Confirmation",
    "payment.contact_required": "Contact Required",
    "payment.confirmed": "Paid / Confirmed",
    "confirm.paywayRedirect": "You will be redirected to ABA PayWay to complete your payment securely. After payment, return to PaMak to complete your order.",
    "confirm.payWithPayway": "PAY WITH ABA PAYWAY",
    "confirm.paywayOpened": "Opened ABA PayWay in a new tab — press the button below after you have paid.",
    "confirm.qrScanInstruction": "Scan this QR with ABA Mobile or a supported KHQR banking app to make your payment.",
    "checkout.telegramPhone": "Telegram Phone Number",
    "checkout.telegramPhonePlaceholder": "+855 XX XXX XXX",
    "checkout.telegramPhoneNote": "Please enter the phone number connected to your Telegram account. The PaMak team will contact you to arrange and confirm your payment.",
    "checkout.telegramPhoneError": "Please enter a valid phone number with country code, e.g. +855 XX XXX XXX.",
    "name.pin": "PaMak Pin",
    "name.strap": "1 Pair of Adjustable Strap",
    "owner.date.all": "All Time",
    "owner.date.today": "Today",
    "owner.date.yesterday": "Yesterday",
    "owner.date.7d": "Last 7 Days",
    "owner.date.30d": "Last 30 Days",
    "owner.date.day": "Custom Date",
    "owner.date.range": "Custom Range",
    "owner.cardTotal": "Total Orders",
    "owner.cardConfirmNeeded": "Payment Confirmation Needed",
    "owner.cardContact": "Contact Required",
    "owner.cardAwaiting": "Awaiting Payment",
    "owner.cardReadyProcess": "Ready to Process",
    "owner.cardPreparing": "Preparing Order",
    "owner.cardReadyDelivery": "Ready for Delivery",
    "owner.cardCompleted": "Completed",
    "owner.cardCancelled": "Cancelled",
    "owner.cardLowStock": "Low Stock Items",
    "owner.ordersInPeriod": "orders in selected period",
    "owner.noOrdersMatch": "No orders match these filters.",
    "owner.searchOrders": "Search order code, customer, phone or Telegram phone…",
    "owner.filterMethod": "Payment method",
    "owner.filterPayStatus": "Payment status",
    "owner.filterOrderStatus": "Order status",
    "owner.all": "All",
    "owner.payOther": "Other Payment Method",
    "owner.telegramPhone": "Telegram Phone",
    "owner.promo": "Promo",
    "owner.subtotal": "Subtotal",
    "owner.customer": "Customer",
    "owner.address": "Address",
    "owner.cancelOrder": "Cancel order",
    "owner.cancelConfirmTitle": "Cancel this order?",
    "owner.cancelConfirmBody": "Order {code} will be marked cancelled. Stock is not affected and the customer is notified on their order page. Are you sure?",
    "owner.lowStockWarn": "⚠ Low Stock",
    "owner.threshold": "Low-stock threshold",
    "owner.stockAdded": "Stock added",
    "owner.stockDeducted": "Stock deducted",
    "owner.history": "Inventory history",
    "owner.noHistory": "No inventory events yet.",
    "owner.histOrder": "Sold",
    "owner.histManual": "Manual update",
    "owner.marketingTab": "Marketing",
    "owner.marketingHint": "Only customers who separately agreed to marketing emails will receive this. Every email includes an unsubscribe link.",
    "owner.marketingNotConfigured": "Marketing sending needs your verified pamakofficial.shop domain first (see the setup guide). Transactional emails are unaffected.",
    "owner.marketingSubject": "Subject",
    "owner.marketingBody": "Message",
    "owner.marketingSend": "SEND TO SUBSCRIBERS",
    "owner.marketingHistory": "Past campaigns",
    "owner.marketingDelivered": "delivered",
    "owner.marketingFailed": "failed",
    "owner.marketingSent": "Marketing email sent to {n} customers ✓",
    "owner.emailVerified": "Email verified",
    "owner.membershipStatus": "Membership",
    "owner.marketingConsent": "Marketing consent",
    "owner.lastEmail": "Last email",
    "owner.emailSent": "sent",
    "owner.emailFailed": "failed",
    "owner.yes": "Yes",
    "owner.no": "No",
    "confirm.continue": "CONTINUE SHOPPING",

    "toast.added": "added to your bag ✓",
    "toast.emptyCart": "Your shopping bag is empty.",
    "toast.orderOk": "Order created successfully ✓",
    "toast.orderFail": "Could not place the order. Please try again.",
    "toast.memberOk": "Welcome to the PaMak Circle ♡",
    "toast.memberEmpty": "Please enter your phone number or email.",
    "toast.soon": "Coming soon",
    "toast.language": "Language switched",

    "checkout.eyebrow": "PAMAK CHECKOUT",
    "checkout.title": "Delivery Information",
    "checkout.name": "Full Name *",
    "checkout.phone": "Phone Number *",
    "checkout.province": "Province / City *",
    "checkout.district": "District / Khan *",
    "checkout.commune": "Commune / Sangkat",
    "checkout.village": "Village / Street / House",
    "checkout.deliveryDetails": "Delivery Details",
    "checkout.remark": "Order Remark",
    "checkout.payment": "Payment Method",
    "checkout.aba": "ABA / KHQR",
    "checkout.other": "Other payment method",
    "checkout.note": "After you place the order, the ABA PayWay / KHQR payment link opens. PaMak confirms your payment shortly after you pay.",
    "checkout.error": "Please complete all required delivery information.",
    "checkout.place": "PLACE ORDER",
    "checkout.summary": "Your Order",

    "footer.shop": "Shop",
    "footer.about": "About PaMak",
    "footer.help": "Help",
    "footer.follow": "Follow Us",
    "footer.allProducts": "All Products",
    "footer.knee": "Knee Support",
    "footer.bag": "Waist Bag",
    "footer.soon": "Coming Soon",
    "footer.ourStory": "Our Story",
    "footer.active": "Active Living",
    "footer.blog": "Blog",
    "footer.faq": "FAQ",
    "footer.delivery": "Delivery",
    "footer.returns": "Returns",
    "footer.contact": "Contact Us",
    "footer.copyright": "© 2026 PaMak. All rights reserved.",
    "footer.tagline": "Stay active. Stay close. PaMak.",
  },

  kh: {
    "nav.home": "ទំព័រដើម",
    "nav.shop": "ទំនិញ",
    "nav.story": "រឿងរបស់យើង",
    "nav.active": "ជីវិតសកម្ម",
    "nav.support": "ជំនួយ",

    "hero.kicker": "សម្រាប់ថ្ងៃស្អែកដែលសកម្មជាង",
    "hero.line1": "លំហាត់ប្រាណ",
    "hero.line2": "ដោយយកចិត្ត",
    "hero.line3": "ទុកដាក់។",
    "hero.copy1": "គ្រប់ជំហាន គ្រប់ថ្ងៃ។",
    "hero.copy2": "PaMak នៅក្បែរមនុស្សដែលអ្នកស្រឡាញ់។",
    "hero.shop": "កម្មង់ឥឡូវនេះ",
    "hero.discover": "យល់ដឹងអំពី PAMAK",
    "hero.note1": "តោះធ្វើលំហាត់ប្រាណ",
    "hero.note2": "ជាមួយគ្នា!",
    "hero.note3": "ដើម្បីខ្លួនឯងនិងមនុស្សជាទីស្រលាញ់",

    "products.eyebrow": "ផលិតផលរបស់យើង",
    "products.title1": "ផលិតឡើងដើម្បី",
    "products.title2": "ធ្វើលំហាត់ប្រាណជាមួយអ្នក។",
    "products.desc": "ផលិតផលជំនួយសាមញ្ញសម្រាប់ជីវិតប្រចាំថ្ងៃ។ រចនាឡើងសម្រាប់ភាពងាយស្រួល ផាសុខភាព និងមនុស្សជាទីស្រលាញ់។",
    "products.viewAll": "មើលផលិតផលទាំងអស់",
    "products.loading": "កំពុងផ្ទុកផលិតផល…",
    "products.empty": "ផលិតផលនឹងមកដល់ឆាប់ៗ។",
    "product.add": "បញ្ចូលទៅកន្ត្រក",
    "product.knee": "គាំងជង្គង់",
    "product.bag": "ថង់ចង្កេះរត់",

    "feature.eyebrow": "គាំងជង្គង់",
    "feature.title1": "ជំនួយការ",
    "feature.title2": "ដែល *ទៅណាមកណា*",
    "feature.title3": "ជាមួយ *អ្នក* ។",
    "feature.desc": "ផលិតឡើងសម្រាប់សកម្មភាពប្រចាំថ្ងៃដូចជា ដើរលេង រត់ហាត់ប្រាណ និងគ្រប់ពេលវេលាសំខាន់ៗផ្សេងៗទៀត។",
    "feature.shop": "ទិញឥឡូវនេះ",
    "feature.learn": "ព័ត៌មានបន្ថែម",
    "callout.fit": "អាចលៃតម្រូវប្រវែងបាន",
    "callout.breathable": "មានរន្ធខ្យល់ចេញចូល",
    "callout.light": "ស្រាល",
    "callout.support": "ជំនួយប្រចាំថ្ងៃ",
    "callout.comfort": "រចនាបថត្រូវនឹងឆ្អឹង",
    "callout.wear": "ងាយស្រួលពាក់",

    "story.eyebrow": "រឿងរ៉ាវរបស់ពួកយើង",
    "story.title1": "សម្រាប់មនុស្ស",
    "story.title2": "ដែលធ្វើឱ្យយើង",
    "story.title3": "*ចលនា* ។",
    "story.desc": "ពីដើរប្រចាំថ្ងៃ ដល់ចុងសប្តាហ៍សកម្ម PaMak បង្កើតផលិតផលជំនួយសាមញ្ញ សម្រាប់ជីវិតប្រចាំថ្ងៃ។",
    "story.btn": "រឿងរបស់យើង",

    "cat.knee": "ខ្សែរឹតជង្គង់",
    "cat.kneeSub": "សកម្មដោយទំនុកចិត្ត។",
    "cat.carry": "ដាក់របស់សំខាន់ៗតាមខ្លួន",
    "cat.carrySub": "កាន់អ្វីដែលអ្នកត្រូវការ។",
    "cat.essentials": "សម្ភារៈសកម្ម",
    "cat.essentialsSub": "ស្រាល សាមញ្ញ មានប្រយោជន៍។",
    "cat.soon": "មកដល់ឆាប់ៗ",
    "cat.soonSub": "ផលិតផលថ្មីៗកំពុងមកដល់។",

    "benefit.delivery": "ដឹកជញ្ជូនក្នុងកម្ពុជា",
    "benefit.deliverySub": "រហ័ស និងអាចទុកចិត្តបាន។",
    "benefit.payment": "ការទូទាត់សុវត្ថិភាព",
    "benefit.paymentSub": "ABA / KHQR រួចរាល់។",
    "benefit.support": "ជំនួយអតិថិជន",
    "benefit.supportSub": "យើងស្ថិតនៅទីនេះដើម្បីជួយ។",
    "benefit.offers": "ការផ្តល់ជូនពិសេស",
    "benefit.offersSub": "រង្វាន់សមាជិក និងបញ្ចុះតម្លៃ។",

    "home.eyebrow": "ទាំងអស់នេះ",
    "home.title1": "បង្កើតដោយ",
    "home.title2": "កូនខ្មែរ។",
    "home.desc": "គោលដៅតែមួយនោះគឺ ការបង្ហាញពីក្តីស្រលាញ់ចំពោះខ្លួននិងជាពិសេសគឺដល់ប៉ាម៉ាក់របស់ពួកយើងដើម្បីសុខភាពពួកគាត់។",

    "member.eyebrow": "សមាជិកភាព",
    "member.title": "ចូលរួមជាសមាជិករបស់",
    "member.desc": "ដឹងពីផលិតផលថ្មី ការផ្តល់ជូន និងរឿងរ៉ាវជីវិតសកម្មមុនគេ។",
    "member.placeholder": "លេខទូរស័ព្ទ ឬអ៊ីមែល",
    "member.join": "ចូលរួម",

    "cart.eyebrow": "កន្ត្រករបស់អ្នក",
    "cart.title": "កន្ត្រកទំនិញ",
    "cart.empty": "កន្ត្រករបស់អ្នកគឺទំនេរ។",
    "cart.empty2": "ចាប់ផ្តើមចលនាជាមួយ PaMak។",
    "cart.subtotal": "តម្លៃរង",
    "cart.delivery": "ការដឹកជញ្ជូន",
    "cart.calc": "គណនាពេលទូទាត់",
    "cart.free": "ឥតគិតថ្លៃ",
    "product.set": "ឈុតសម្រាប់ប៉ាម៉ាក់",
    "set.badge": "ខ្សែឥតគិតថ្លៃ 2",
    "set.includes": "រួមបញ្ចូល ខ្សែកែតម្រូវឥតគិតថ្លៃ 2 + ខ្ទប់ PaMak",
    "cat.set": "ឈុតសាកសមបំផុតសម្រាប់ប៉ាម៉ាក់",
    "cat.setSub": "អ្វីៗសម្រាប់ឪពុកម្តាយសកម្ម។",
    "search.placeholder": "ស្វែងរកផលិតផល…",
    "story.page.eyebrow": "THE STORY BEHIND PAMAK",
    "story.page.heroTitle": "Two Students. One Dream. A Little Love That Started It All.",
    "story.page.heroLine": "Every meaningful journey begins somewhere. Ours began with family.",
    "story.page.timeline": "Our Journey Timeline",
    "story.page.chapterNav": "Jump to a chapter",
    "story.page.withLove": "With love,",
    "story.page.coFounders": "Co-founders of PaMak",
    "story.page.sloganLine": "From Our Generation, With Love for Every Generation.",
    "story.page.slogan": "ONE ACT OF LOVE, A WAVE OF CARE.",
    "story.page.explore": "Explore Our Products",
    "story.page.share": "Share Our Story",
"shop.catAll": "ទាំងអស់",
    "shop.catAddons": "ផលិតផលបន្ថែម",
    "details.pin.about": "ប៊ិចសំគាល់ផ្លាក PaMak ដែលអ្នកអាចពាក់បានគ្រប់ទីកន្លែង។",
    "details.pin.features": "រចនាបថផ្លាក PaMak|តូច និងស្រាល|ភ្ជាប់ងាយស្រួល",
    "details.pin.use": "ភ្ជាប់ទៅលើខោអាវ កាបូប ឬមួករបស់អ្នក។",
    "details.strap.about": "ខ្សែរឹតកែប្រែប្រវែង 1 គូ សម្រាប់កែសម្រួលការពាក់ជំនួយជង្គង់របស់អ្នក។",
    "details.strap.features": "បានមកជាគូ|កែប្រែប្រវែងបាន|ងាយស្រួលលាង",
    "details.strap.use": "ប្រើដើម្បីកែសម្រួលការពាក់ជំនួយជង្គង់ PaMak របស់អ្នក។",
    "search.none": "រកមិនឃើញផលិតផលត្រូវនឹងការស្វែងរក។",
    "auth.login": "ចូលគណនី",
    "auth.register": "ចុះឈ្មោះ",
    "auth.name": "ឈ្មោះពេញ",
    "auth.email": "អ៊ីមែល",
    "auth.phone": "លេខទូរស័ព្ទ",
    "auth.password": "ពាក្យសម្ងាត់",
    "auth.logout": "ចាកចេញ",
    "auth.myOrders": "ការបញ្ជាទិញរបស់ខ្ញុំ",
    "auth.ownerPanel": "ផ្ទាំងគ្រប់គ្រង",
    "auth.points": "ពិន្ទុ",
    "auth.earn": "ទទួលពិន្ទុ 1 គ្រប់ $1 ដែលចំណាយ។",
    "auth.guestNote": "បញ្ជាទិញជាភ្ញៀវ — ចូលគណនីដើម្បីទទួលពិន្ទុ",
    "auth.welcome": "សូមស្វាគមន៍ត្រឡប់មកវិញ",
    "auth.created": "បង្កើតគណនីបានជោគជ័យ។ សូមស្វាគមន៍មកកាន់ PaMak!",
    "auth.needLogin": "សូមចូលគណនីដើម្បីមើលការបញ្ជាទិញរបស់អ្នក។",
    "auth.ownerNeedLogin": "ត្រូវការចូលគណនីម្ចាស់ហាងដើម្បីមើលការបញ្ជាទិញ។",
    "confirm.title": "បញ្ជាទិញបានសម្រេច!",
    "confirm.thanks": "សូមអរគុណ — ការបញ្ជាទិញរបស់អ្នកបានទទួល។",
    "confirm.id": "លេខកូដបញ្ជាទិញរបស់អ្នក",
    "confirm.remark": "ប្រើលេខកូដនេះជា Remark ពេលបង់ប្រាក់តាម ABA។",
    "confirm.copiedCheck": "ខ្ញុំបានចម្លងលេខកូដបញ្ជាទិញរួចរាល់",
    "confirm.paynow": "បន្តទៅ ABA PAYWAY",
    "confirm.otherNote": "អ្នកបានជ្រើសរើសវិធីបង់ប្រាក់ផ្សេង។ ក្រុមការងាររបស់យើងនឹងទំនាក់ទំនងមករកអ្នកដើម្បីរៀបចំការទូទាត់ — គាត់មិនគិតថ្លៃតាមរយៈគេហទំព័រនេះទេ។",
    "checkout.paywayTitle": "បង់ប្រាក់តាម ABA PayWay",
    "checkout.paywayNote": "សម្រាប់អតិថិជន ABA",
    "checkout.bakongTitle": "បង់ប្រាក់តាម Bakong",
    "checkout.bakongNote": "សម្រាប់ ABA និងកម្មវិធីធនាគារដែលគាំទ្រ",
    "confirm.orderCodeLabel": "លេខកូដបញ្ជាទិញ:",
    "confirm.amountLabel": "ចំនួនទឹកប្រាក់:",
    "confirm.paywayHint": "បង់ប្រាក់តាមកម្មវិធី ABA បន្ទាប់មកត្រឡប់មកវិញ ហើយចុចប៊ូតុងបៃតងខាងក្រោម។",
    "confirm.remarkLabel": "Remark",
    "confirm.qrBanksNote": "ដំណើរការជាមួយ ABA និងកម្មវិធីធនាគារដែលគាំទ្រ។",
    "confirm.completedPayment": "ខ្ញុំបានទូទាត់រួចរាល់",
    "confirm.completedHint": "ចុចតែពេលបានបង់ប្រាក់រួចហើយ — PaMak នឹងផ្ទៀងផ្ទាត់ការទូទាត់របស់អ្នកឆាប់ៗ។",
    "confirm.submittedOk": "បានអាប់ដេតស្ថានភាព — សូមអរគុណ!",
    "confirm.submittedMsg": "ការទូទាត់របស់អ្នកកំពុងរង់ចាំការផ្ទៀងផ្ទាត់ពីក្រុមការងារ PaMak។ សូមកុំបារម្ភ ប្រសិនបើអ្នកបានទូទាត់រួច — យើងនឹងអាប់ដេតស្ថានភាពបន្ទាប់ពីផ្ទៀងផ្ទាត់។",
    "confirm.refPlaceholder": "លេខប្រតិបត្តិការ ABA (ស្រេចចិត្ត)",
    "confirm.receiptLabel": "បញ្ចូលរូបភាពបង្កាន់ដៃការទូទាត់ (ស្រេចចិត្ត)",
    "confirm.receiptTooBig": "រូបភាពធំពេក — សូមប្រើឯកសារតិចជាង 5MB។",
    "confirm.sendInfo": "ផ្ញើទៅ PAMAK",
    "confirm.sentOk": "បានទទួល — យើងនឹងផ្ទៀងផ្ទាត់ការទូទាត់របស់អ្នកឆាប់ៗ។",
    "auth.changePassword": "ប្ដូរពាក្យសម្ងាត់",
    "auth.currentPassword": "ពាក្យសម្ងាត់បច្ចុប្បន្ន",
    "auth.newPassword": "ពាក្យសម្ងាត់ថ្មី",
    "auth.pwChanged": "បានប្ដូរពាក្យសម្ងាត់ ✓",
    "auth.pwMismatch": "ពាក្យសម្ងាត់បច្ចុប្បន្នមិនត្រឹមត្រូវ។",
    "auth.unavailable": "គណនីរបស់អ្នកបច្ចុប្បន្នមិនអាចប្រើបានទេ។ សូមទំនាក់ទំនង PaMak សម្រាប់ជំនួយ។",
    "member.level.member": "សមាជិក",
    "member.level.silver": "សមាជិកប្រាក់",
    "member.level.gold": "សមាជិកមាស",
    "owner.dashboard": "ផ្ទាំងគ្រប់គ្រង",
    "owner.ordersTab": "ការបញ្ជាទិញ និងការទូទាត់",
    "owner.usersTab": "គ្រប់គ្រងអតិថិជន",
    "owner.activityTab": "កត់ត្រាសកម្មភាព",
    "owner.payway": "ABA PayWay",
    "owner.payQr": "ABA QR",
    "owner.paymentRef": "លេខប្រតិបត្តិការ",
    "owner.receipt": "បង្កាន់ដៃ",
    "owner.viewReceipt": "មើលបង្កាន់ដៃ",
    "owner.noReceipt": "មិនមានបង្កាន់ដៃបញ្ចូលទេ។",
    "owner.confirmPayTitle": "បញ្ជាក់ការទូទាត់?",
    "owner.confirmPayBody": "សូមពិនិត្យការទូទាត់ ABA សម្រាប់ {code} មុនពេលបញ្ជាក់។ ការបញ្ជាទិញនឹងអាប់ដេតរាល់កន្លែង ហើយ Telegram នឹងទទួលការជូនដំណឹង។",
    "owner.cancel": "បោះបង់",
    "owner.confirmedRevenue": "ប្រាក់ចំណូលបានបញ្ជាក់",
    "owner.updated": "បានអាប់ដេត ✓",
    "owner.searchUsers": "ស្វែងរកតាមឈ្មោះ អ៊ីមែល លេខទូរស័ព្ទ ឬ ID…",
    "owner.searchBtn": "ស្វែងរក",
    "owner.noUsers": "រកមិនឃើញគណនីអតិថិជនទេ។",
    "owner.userId": "ID អតិថិជន",
    "owner.registered": "ចុះឈ្មោះ",
    "owner.lastLogin": "ចូលលើកចុងក្រោយ",
    "owner.totalSpent": "ចំណាយសរុប",
    "owner.ordersCount": "បញ្ជាទិញ",
    "owner.saveProfile": "រក្សាទុក",
    "owner.suspend": "ផ្អាកគណនី",
    "owner.disable": "បិទគណនី",
    "owner.reEnable": "បើកគណនីឡើងវិញ",
    "owner.resetPwd": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
    "owner.orderHistory": "ប្រវត្តិបញ្ជាទិញ",
    "owner.uStatus.active": "សកម្ម",
    "owner.uStatus.suspended": "កំពុងផ្អាក",
    "owner.uStatus.disabled": "បានបិទ",
    "owner.confirmSuspendTitle": "ផ្អាកគណនីនេះ?",
    "owner.confirmDisableTitle": "បិទគណនីនេះ?",
    "owner.confirmReenableTitle": "បើកគណនីនេះឡើងវិញ?",
    "owner.confirmBody": "តើអ្នកប្រាកដទេសម្រាប់ {name}? ការបញ្ជាទិញ ការទូទាត់ និងពិន្ទុរបស់ពួកគេនឹងត្រូវបានរក្សាទុក។",
    "owner.confirmResetTitle": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ?",
    "owner.confirmResetBody": "ពាក្យសម្ងាត់បណ្ដោះអាសន្ននឹងត្រូវបង្កើតសម្រាប់ {name}។ អ្នកត្រូវផ្តល់វាឲ្យអតិថិជន — អ្នកមិនអាចមើលពាក្យសម្ងាត់ដើមរបស់ពួកគេបានទេ។",
    "owner.tempPwTitle": "បានបង្កើតពាក្យសម្ងាត់បណ្ដោះអាសន្ន",
    "owner.tempPwBody": "ពាក្យសម្ងាត់បណ្ដោះអាសន្ន (តែម្តងគត់) សម្រាប់ {name}:",
    "owner.tempPwNote": "ផ្តល់វាឲ្យអតិថិជន ហើយសូមឱ្យពួកគេចូលក្នុងគណនី រួចប្ដូរវាភាគៃ។ អ្នកនឹងមិនឃើញវាម្តងទៀតទេ។",
    "owner.done": "រួចរាល់",
    "owner.byAdmin": "ដោយ",
    "owner.noActivity": "មិនមានសកម្មភាពទេ។",
    "name.knee": "ជ័ររឹតជំនួយជង្គង់ PaMak",
    "name.bag": "កាបូបចង្កេះសម្រាប់រត់ PaMak",
    "name.set": "PaMak Parent Set",
    "product.whyTitle": "ចំណុចពិសេស",
    "product.viewDetails": "ព័ត៌មានលម្អិតអំពីផលិតផល",
    "product.hideDetails": "លាក់ព័ត៌មានលម្អិត",
    "product.about": "អំពីផលិតផលនេះ",
    "product.features": "ចំណុចពិសេស",
    "product.use": "របៀបប្រើ",
    "product.inStock": "មានស្តុក",
    "product.soldOut": "អស់ស្តុក",
    "product.onlyLeft": "មានតែ {n} ទៀតប៉ុណ្ណោះ",
    "benefits.knee": "ជួយទ្រទ្រង់ជង្គង់សម្រាប់សកម្មភាពប្រចាំថ្ងៃ|អាចកែតម្រូវឱ្យសមតាមការពាក់បាន|ស្រាល និងមានផាសុកភាពពេលពាក់|សមស្របសម្រាប់ដើរ រត់ និងសកម្មភាពប្រចាំថ្ងៃ",
    "benefits.bag": "ស្រាល និងងាយស្រួលសម្រាប់សកម្មភាពប្រចាំថ្ងៃ|មានផ្នែកច្រើនសម្រាប់ដាក់សម្ភារៈ|ខ្សែចង្កេះអាចកែតម្រូវបាន|មានផ្នែកឆ្លុះពន្លឺសម្រាប់បង្កើនការមើលឃើញ",
    "details.knee.about": "ខ្សែទ្រទ្រង់ជង្គង់ PaMak ត្រូវបានរចនាឡើងសម្រាប់ការធ្វើចលនា និងការប្រើប្រាស់ប្រចាំថ្ងៃ ដោយផ្តល់នូវការរុំព័ទ្ធ និងការទ្រទ្រង់ជុំវិញតំបន់ជង្គង់ក្នុងកម្រិតសមស្រប ខណៈពេលដែលអ្នកនៅតែអាចធ្វើសកម្មភាពបានយ៉ាងងាយស្រួល។|រូបរាងដែលរចនាតាមទម្រង់ជង្គង់ ជួយឱ្យការពាក់មានផាសុកភាព ហើយផ្នែកទន់សម្រាប់ទ្រទ្រង់ជួយបន្ថែមភាពស្រួលនៅពេលធ្វើចលនា។|ខ្សែអាចកែតម្រូវបាន ដើម្បីឱ្យអ្នកអាចរៀបចំកម្រិតនៃការរឹតបន្តឹងឱ្យសមនឹងការពាក់របស់អ្នក។|ការរចនាស្រាល និងមានផាសុកភាព ធ្វើឱ្យវាសមស្របសម្រាប់ការដើរ ហាត់ប្រាណស្រាល រត់ លោតខ្សែ និងសកម្មភាពកម្សាន្តផ្សេងៗ។",
    "details.knee.features": "រចនាតាមទម្រង់ជង្គង់|មានផ្នែកទន់សម្រាប់ជួយទ្រទ្រង់|ខ្សែអាចកែតម្រូវបាន|ទម្ងន់ស្រាល|រចនាឱ្យពាក់មានផាសុកភាព|មិនរារាំងការធ្វើចលនាប្រចាំថ្ងៃ|សមស្របសម្រាប់សកម្មភាពប្រចាំថ្ងៃ និងការហាត់ប្រាណ",
    "details.knee.use": "ពាក់ឧបករណ៍ជុំវិញជង្គង់ ហើយកែតម្រូវខ្សែឱ្យមានអារម្មណ៍ថាជាប់ល្អ និងមានផាសុកភាព។ កុំរឹតតឹងពេក។ ផលិតផលនេះត្រូវបានរចនាសម្រាប់ការទ្រទ្រង់ និងផាសុកភាពក្នុងសកម្មភាពប្រចាំថ្ងៃ និងការហាត់ប្រាណទូទៅ។",
    "details.bag.about": "កាបូបចង្កេះសម្រាប់រត់ PaMak ត្រូវបានរចនាឡើងឱ្យអ្នកអាចយកសម្ភារៈចាំបាច់ទៅជាមួយបានយ៉ាងងាយស្រួល ដោយមិនចាំបាច់កាន់កាបូបធំ។|រូបរាងស្តើង និងស្រាល ធ្វើឱ្យវាសមស្របសម្រាប់ការរត់ ដើរ ហាត់ប្រាណ ធ្វើដំណើរ និងសកម្មភាពប្រចាំថ្ងៃ។|កាបូបមានផ្នែកច្រើន ដើម្បីងាយស្រួលរៀបចំទូរស័ព្ទ សោ កាត ប្រាក់ និងសម្ភារៈតូចៗផ្សេងទៀតដោយឡែកពីគ្នា។|ខ្សែចង្កេះអាចកែតម្រូវបាន ដើម្បីឱ្យសមនឹងអ្នកប្រើប្រាស់ផ្សេងៗ និងអាចកែឱ្យតឹង ឬធូរតាមផាសុកភាព។",
    "details.bag.features": "ទម្ងន់ស្រាល ប្រហែល 70 ក្រាម តាមព័ត៌មានពីអ្នកផ្គត់ផ្គង់|ខ្សែចង្កេះអាចកែតម្រូវបាន|សម្រាប់ទំហំចង្កេះប្រហែល 55–120 សម. តាមព័ត៌មានពីអ្នកផ្គត់ផ្គង់|មានផ្នែកដាក់សម្ភារៈច្រើន / រចនា 3 ផ្នែក|អាចដាក់ទូរស័ព្ទទំហំប្រហែល 7.5 អ៊ីញ ឬតូចជាងនេះ តាមព័ត៌មានពីអ្នកផ្គត់ផ្គង់|អាចដាក់ទូរស័ព្ទ សោ កាត ប្រាក់ និងសម្ភារៈតូចៗ|មានផ្នែកឆ្លុះពន្លឺ ដើម្បីបង្កើនការមើលឃើញ|សម្ភារៈបត់បែន និងមានផាសុកភាព|សាច់ក្រណាត់ធន់នឹងទឹកបន្តិច សមស្របសម្រាប់ញើស និងទឹកប៉ះប្រចាំថ្ងៃ|រូបរាងស្តើង និងនៅជិតរាងកាយពេលពាក់|សមស្របសម្រាប់រត់ ដើរ ហាត់ប្រាណ ធ្វើដំណើរ និងប្រើប្រាស់ប្រចាំថ្ងៃ",
    "details.bag.use": "កែតម្រូវខ្សែចង្កេះឱ្យសម និងមានផាសុកភាព បន្ទាប់មកដាក់សម្ភារៈចាំបាច់ក្នុងផ្នែកនីមួយៗ ហើយបិទខ្សែរ៉ូតឱ្យជិតមុនពេលធ្វើសកម្មភាព។",
    "stock.liveNote": "ស្តុកភ្លាមៗ — ប្តូរតាមការបញ្ជាទិញ",
    "owner.recheckPayway": "ពិនិត្យជាមួយ PAYWAY",
    "owner.paywayStatus": "ស្ថានភាព PayWay",
    "confirm.qrReady": "QR សម្រាប់ទូទាត់របស់អ្នករួចរាល់ហើយ",
    "confirm.paywayScanHint": "ស្កេនកូដនេះដោយកម្មវិធីធនាគារណាមួយដែលគាំទ្រ — ចំនួនទឹកប្រាក់ត្រូវបានកំណត់រួចសម្រាប់ការបញ្ជាទិញនេះ។",
    "confirm.openAbaApp": "បើកកម្មវិធី ABA ដើម្បីបង់ប្រាក់",
    "confirm.autoVerifyHint": "បន្ទាប់ពីបង់ប្រាក់ ចុចប៊ូតុងបៃតងខាងក្រោម — PaMak ផ្ទៀងផ្ទាត់ជាមួយ PayWay ដោយស្វ័យប្រវត្តិ។",
    "confirm.sandboxNotice": "របៀបសាកល្បង (PayWay sandbox)៖ QR នេះសម្រាប់សាកល្បងប៉ុណ្ណោះ។ កម្មវិធី ABA Mobile ពិតមិនអាចបង់ប្រាក់បានទេ ហើយនឹងបង្ហាញ \"Transaction not found\"។ ការបង់ប្រាក់ពិតនឹងដំណើរការ នៅពេល PaMak ប្តូរទៅប្រើគណនី PayWay ផ្លូវការ (live)។",
    "confirm.diagTitle": "ព័ត៌មានបច្ចេកទេសបណ្តោះអាសន្ន (សាកល្បងក្នុង SANDBOX)",
    "confirm.diagErrorTitle": "ព័ត៌មានកំហុស PayWay (SANDBOX)",
    "confirm.diagEnv": "Environment",
    "confirm.diagTranId": "លេខប្រតិបត្តិការ PayWay",
    "confirm.diagStatus": "កូដស្ថានភាព PayWay",
    "confirm.diagMessage": "សារពី PayWay",
    "confirm.diagTrace": "Trace ID",
    "confirm.paywayUnpaid": "PayWay មិនទាន់អាចបញ្ជាក់ការទូទាត់នេះបានទេ។ ស្ថានភាព៖",
    "confirm.paywayPaidOk": "PayWay បានបញ្ជាក់ការទូទាត់រួចរាល់ — សូមអរគុណ!",
    "auth.confirmPw": "បញ្ជាក់ពាក្យសម្ងាត់",
    "auth.pwMismatch": "ពាក្យសម្ងាត់មិនត្រូវគ្នាទេ។",
    "auth.forgotLink": "ភ្លេចពាក្យសម្ងាត់?",
    "auth.codeLabel": "កូដ ៦ ខ្ទង់",
    "auth.verifyTitle": "ផ្ទៀងផ្ទាត់អ៊ីមែលរបស់អ្នក",
    "auth.verifyDesc": "យើងបានផ្ញើកូដ ៦ ខ្ទង់ទៅ {email}។ សូមបញ្ចូលខាងក្រោមដើម្បីផ្ទៀងផ្ទាត់អ៊ីមែលរបស់អ្នក។",
    "auth.verifyBtn": "ផ្ទៀងផ្ទាត់អ៊ីមែល",
    "auth.resendBtn": "ផ្ញើកូដម្តងទៀត",
    "auth.resendOk": "កូដថ្មីត្រូវបានផ្ញើ — សូមពិនិត្យក្នុងប្រអប់អ៊ីមែលរបស់អ្នក។",
    "auth.verifiedOk": "សូមស្វាគមន៍មកកាន់ PaMak! អ៊ីមែលរបស់អ្នកត្រូវបានផ្ទៀងផ្ទាត់ដោយជោគជ័យ។",
    "auth.forgotTitle": "ភ្លេចពាក្យសម្ងាត់",
    "auth.forgotDesc": "បញ្ចូលអ៊ីមែលរបស់អ្នក យើងនឹងផ្ញើកូដកំណត់ពាក្យសម្ងាត់ឡើងវិញ។",
    "auth.forgotBtn": "ផ្ញើកូដកំណត់ឡើងវិញ",
    "auth.forgotOk": "ប្រសិនបើមានគណនីជាមួយអ៊ីមែលនេះ យើងបានផ្ញើសេចក្តីណែនាំក្នុងការកំណត់ពាក្យសម្ងាត់ឡើងវិញ។",
    "auth.resetTitle": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
    "auth.newPw": "ពាក្យសម្ងាត់ថ្មី",
    "auth.resetBtn": "ផ្លាស់ប្តូរពាក្យសម្ងាត់",
    "auth.resetOk": "ពាក្យសម្ងាត់របស់អ្នកត្រូវបានផ្លាស់ប្តូរដោយជោគជ័យ។ សូមចូលដោយប្រើពាក្យសម្ងាត់ថ្មី។",
    "auth.backToLogin": "ត្រឡប់ទៅការចូលគណនី",
    "auth.verifyNow": "ផ្ទៀងផ្ទាត់អ៊ីមែលរបស់អ្នក",
    "auth.notVerified": "អ៊ីមែលមិនទាន់ផ្ទៀងផ្ទាត់",
    "auth.memberBadge": "សមាជិក PaMak",
    "auth.done": "រួចរាល់",
    "member.namePlaceholder": "ឈ្មោះពេញ",
    "member.emailPlaceholder": "អាសយដ្ឋានអ៊ីមែល",
    "member.agree": "ខ្ញុំយល់ព្រមចូលរួមក្នុងកម្មវិធីសមាជិកភាព PaMak និងយល់ព្រមតាម",
    "member.termsLink": "លក្ខខណ្ឌ និងកិច្ចសន្យាសមាជិកភាព",
    "member.privacyLink": "លក្ខខណ្ឌភាពឯកជន",
    "member.marketing": "ខ្ញុំចង់ទទួលព័ត៌មាន PaMak, ការប្រកាសផលិតផលថ្មី, អត្ថប្រយោជន៍សមាជិក, ការបញ្ចុះតម្លៃ និងការផ្តល់ជូនពិសេសតាមអ៊ីមែល។",
    "member.agreeRequired": "សូមព្រមព្រៀងលក្ខខណ្ឌសមាជិកភាពដើម្បីចូលរួម PaMak Circle។",
    "member.alreadyAccount": "អ្នកជាសមាជិក PaMak រួចហើយ។ សូមចូលគណនីដើម្បីមើលសមាជិកភាពរបស់អ្នក។",
    "member.alreadyMember": "អ្នកជាសមាជិក PaMak រួចហើយ។",
    "member.termsTitle": "លក្ខខណ្ឌ និងកិច្ចសន្យាសមាជិកភាព",
    "member.termsBody": "ការចូលរួម PaMak Circle គឺឥតគិតថ្លៃ។ សមាជិកប្រមូលពិន្ទុ PaMak លើការបញ្ជាទិញដែលបានបញ្ចប់ និងអាចទទួលអត្ថប្រយោជន៍សមាជិកពេលចាប់ផ្តើមមាន។ ពិន្ទុមិនមានតម្លៃសាច់ប្រាក់ និងមិនអាចដូរយកបាននៅឡើយទេ។ PaMak អាចធ្វើបច្ចុប្បន្នភាពលក្ខខណ្ឌទាំងនេះ។ អ្នកអាចឈប់ជាសមាជិកនៅពេលណាមួយតាមរយៈការទំនាក់ទំនងជាមួយ PaMak។",
    "member.privacyTitle": "លក្ខខណ្ឌភាពឯកជន",
    "member.privacyBody": "PaMak រក្សាទុកឈ្មោះ អ៊ីមែល និងស្ថានភាពសមាជិកភាពរបស់អ្នក ដើម្បីដំណើរការកម្មវិធីសមាជិកភាព។ ការព្រមព្រៀង និងការជ្រើសរើសទទួលព័ត៌មានផ្សព្វផ្សាយត្រូវរក្សាទុកដាច់ដោយឡែក ព្រមទាំងកាលបរិច្ឆេទនៃការយល់ព្រម។ អ៊ីមែលផ្សព្វផ្សាយត្រូវផ្ញើតែពេលអ្នកបានយល់ព្រមប៉ុណ្ណោះ ហើយមានតំណលុបចេញរាល់ដង។ យើងមិនលក់ទិន្នន័យរបស់អ្នកទេ។ ពាក្យសម្ងាត់ត្រូវរក្សាទុកដោយសុវត្ថិភាព ហើយបុគ្គលិក PaMak មិនអាចអានបានទេ។",
    "mpage.title": "សមាជិកភាព PaMak",
    "mpage.statusLabel": "ស្ថានភាពសមាជិក",
    "mpage.statusActive": "សមាជិកសកម្ម",
    "mpage.statusNone": "មិនទាន់ជាសមាជិក",
    "mpage.pointsLabel": "ពិន្ទុសរុប",
    "mpage.sinceLabel": "ជាសមាជិកតាំងពី",
    "mpage.idLabel": "លេខសមាជិក",
    "mpage.badge": "សមាជិក PaMak",
    "mpage.rewardsTitle": "រង្វាន់ PaMak — នឹងមកដល់ឆាប់ៗ",
    "mpage.rewardsDesc": "ពិន្ទុ PaMak របស់អ្នកនឹងឆាប់តែបើកផ្តល់រង្វាន់ពិសេស អត្ថប្រយោជន៍សមាជិក និងការបញ្ចុះតម្លៃ។ សូមបន្តប្រមូលពិន្ទុ — រង្វាន់ថ្មីៗកំពុងមកដល់។",
    "mpage.joinCta": "ចូលរួម PaMak Circle",
    "mpage.loginNeeded": "សូមចូលគណនីដើម្បីមើលសមាជិកភាពរបស់អ្នក។",
    "owner.membersTab": "សមាជិក",
    "owner.mTotal": "សមាជិកសរុប",
    "owner.mNew": "សមាជិកថ្មី",
    "owner.mVerified": "សមាជិកដែលបានផ្ទៀងផ្ទាត់",
    "owner.mMarketing": "អ្នកទទួលព័ត៌មានផ្សព្វផ្សាយ",
    "owner.mSearch": "ស្វែងរកឈ្មោះ អ៊ីមែល ឬលេខសមាជិក",
    "owner.mMarketingAll": "គ្រប់ស្ថានភាពយល់ព្រម",
    "owner.mMarketingYes": "ព័ត៌មានផ្សព្វផ្សាយ: ព្រម",
    "owner.mMarketingNo": "ព័ត៌មានផ្សព្វផ្សាយ: មិនព្រម",
    "owner.mJoined": "ចូលរួម",
    "owner.mVerifiedY": "បានផ្ទៀងផ្ទាត់",
    "owner.mVerifiedN": "មិនទាន់ផ្ទៀងផ្ទាត់",
    "owner.mLastOrder": "ការបញ្ជាទិញចុងក្រោយ",
    "owner.mOrders": "ការបញ្ជាទិញ",
    "owner.mSpent": "ចំណាយសរុប",
    "owner.mLifetime": "ពិន្ទុសរុបដែលបានប្រមូល",
    "owner.mNoMembers": "មិនទាន់មានសមាជិក PaMak ទេ។",
    "owner.mNoMatch": "រកមិនឃើញសមាជិកតាមការស្វែងរកនេះទេ។",
    "checkout.promoLabel": "កូដបញ្ចុះតម្លៃ",
    "checkout.promoPlaceholder": "បញ្ចូលកូដបញ្ចុះតម្លៃ",
    "checkout.promoApply": "អនុវត្ត",
    "checkout.promoRemove": "លុបចេញ",
    "checkout.promoApplied": "កូដបញ្ចុះតម្លៃត្រូវបានអនុវត្តដោយជោគជ័យ!",
    "checkout.youSaved": "អ្នកសំចៃបាន",
    "checkout.promoInvalid": "កូដបញ្ចុះតម្លៃនេះមិនត្រឹមត្រូវ ផុតកំណត់ មិនសកម្ម ឬមិនអាចអនុវត្តលើការបញ្ជាទិញនេះទេ។",
    "checkout.promoLine": "កូដបញ្ចុះតម្លៃ៖",
    "confirm.earnedAfter": "ពិន្ទុដែលអ្នកនឹងទទួលបានបន្ទាប់ពីបង់ប្រាក់៖",
    "confirm.outOfStockTitle": "អស់ស្តុក",
    "confirm.outOfStock": "ការទូទាត់របស់អ្នកបានជោគជ័យ ប៉ុន្តែទំនិញនេះនឹងអស់ស្តុកទំពរា។ PaMak នឹងទំនាក់ទំនងជាមួយអ្នកដើម្បីរៀបចំការបង្វិលប្រាក់វិញ ឬជ្រើសរើសពណ៌ផ្សេង។",
    "member.pitch": "ដើម្បីជាអ្នកដំបូងបង្អស់ដែលឃើញពីផលិតផលថ្មីរបស់ពួកយើង ក៏ដូចជាទទួលបានអត្ថប្រយោជន៍ផ្សេងៗពីពួកយើង។",
    "member.joinBtn": "ចូលរួម",
    "member.modalJoinBtn": "ចូលរួម PAMAK CIRCLE",
    "owner.pActive": "សកម្ម (កូដអាចប្រើបាន)",
    "member.modalTitle": "ចូលរួម PaMak Circle",
    "member.modalWelcome": "ក្លាយជាផ្នែកនៃសហគមន៍ PaMak និងរក្សាទំនាក់ទំនងជាមួយអ្វីៗដែលកំពុងមកដល់។",
    "member.agreeComms": "ខ្ញុំចង់ចូលរួមក្នុងកម្មវិធីសមាជិកភាព PaMak និងទទួលព័ត៌មានសំខាន់ៗដែលទាក់ទងនឹងសមាជិកភាព PaMak របស់ខ្ញុំ។",
    "member.successTitle": "សូមស្វាគមន៍មកកាន់ PaMak Circle 🌸",
    "member.successDesc": "សូមពិនិត្យអ៊ីមែលរបស់អ្នក ដើម្បីបញ្ចប់សមាជិកភាពរបស់អ្នក។",
    "member.successToast": "សូមស្វាគមន៍មកកាន់ PaMak Circle 🌸 សូមពិនិត្យអ៊ីមែលរបស់អ្នក ដើម្បីបញ្ចប់សមាជិកភាព។",
    "member.welcomeActive": "សូមស្វាគមន៍មកកាន់ PaMak Circle 🌸 សមាជិកភាពរបស់អ្នកឥឡូវសកម្មហើយ។",
    "member.verifyHere": "បញ្ចូលកូដ ៦ ខ្ទង់ពីអ៊ីមែលរបស់អ្នក ដើម្បីបញ្ចប់ភ្លាមៗនេះ៖",
    "member.verifyBtn": "ផ្ទៀងផ្ទាត់ និងដាក់សកម្ម",
    "member.alreadyCircle": "អ្នកជាសមាជិក PaMak Circle រួចហើយ។ សូមចូលគណនីដើម្បីមើលសមាជិកភាព និងពិន្ទុរបស់អ្នក។",
    "mpage.statusPending": "កំពុងរង់ចាំការផ្ទៀងផ្ទាត់",
    "mpage.pendingNote": "ជំហានចុងក្រោយ៖ ផ្ទៀងផ្ទាត់អ៊ីមែលរបស់អ្នក ដើម្បីដាក់សមាជិកភាពឲ្យសកម្ម។ សូមពិនិត្យក្នុងប្រអប់អ៊ីមែលរបស់អ្នក។",
    "owner.promosTab": "កូដបញ្ចុះតម្លៃ",
    "owner.pNew": "បង្កើតកូដថ្មី",
    "owner.pCode": "កូដបញ្ចុះតម្លៃ",
    "owner.pCampaign": "ឈ្មោះយុទ្ធនាការ",
    "owner.pType": "ប្រភេទបញ្ចុះតម្លៃ",
    "owner.pPercent": "ភាគរយ",
    "owner.pFixed": "ចំនួនទឹកប្រាក់កំណត់",
    "owner.pValue": "តម្លៃបញ្ចុះ",
    "owner.pMaxDiscount": "បញ្ចុះតម្លៃអតិបរមា (ភាគរយ)",
    "owner.pMaxShort": "អតិបរមា",
    "owner.pMinOrder": "ចំនួនទឹកប្រាក់បញ្ជាទិញអប្បបរមា",
    "owner.pStart": "កាលបរិច្ឆេទ និងពេលចាប់ផ្តើម",
    "owner.pEnd": "កាលបរិច្ឆេទ និងពេលបញ្ចប់",
    "owner.pUsageLimit": "កម្រិតប្រើប្រាស់សរុប (ចាកចេញទំនេរ = គ្មានកំណត់)",
    "owner.pPerCustomer": "កម្រិតប្រើប្រាស់ក្នុងម្នាក់ (ទំនេរ = គ្មានកំណត់)",
    "owner.pRequiresLogin": "អតិថិជនត្រូវចូលគណនី",
    "owner.pMembersOnly": "សមាជិក PaMak តែប៉ុណ្ណោះ",
    "owner.pProducts": "ផលិតផលដែលអាចប្រើ (ទំនេរ = ទាំងអស់)",
    "owner.pCategory": "ប្រភេទដែលអាចប្រើ (ទំនេរ = ទាំងអស់)",
    "owner.pExcluded": "ផលិតផលដែលដកចេញ",
    "owner.pAppliesTo": "អនុវត្តលើ",
    "owner.pProductsOnly": "ផលិតផលតែប៉ុណ្ណោះ",
    "owner.pShipping": "ការដឹកជញ្ជូន",
    "owner.pDescription": "កំណត់សម្គាល់យុទ្ធនាការ",
    "owner.pSave": "រក្សាទុកកូដ",
    "owner.pEdit": "កែសម្រួល",
    "owner.pDuplicate": "ចម្លង",
    "owner.pDisable": "បិទ",
    "owner.pEnable": "បើក",
    "owner.pDelete": "លុប",
    "owner.pUsed": "បានប្រើ",
    "owner.pRemaining": "នៅសល់",
    "owner.pDiscountGiven": "បញ្ចុះសរុប",
    "owner.pSales": "លក់បានសរុប",
    "owner.pOrders": "ការបញ្ជាទិញដែលបានបង់",
    "owner.pSearch": "ស្វែងរកកូដបញ្ចុះតម្លៃ",
    "owner.pUnlimited": "គ្មានកំណត់",
    "owner.pFilterAll": "គ្រប់ស្ថានភាព",
    "owner.pFilterActive": "សកម្ម",
    "owner.pFilterScheduled": "កំណត់ពេល",
    "owner.pFilterExpired": "ផុតកំណត់",
    "owner.pFilterDisabled": "បានបិទ",
    "owner.pFilterExhausted": "ដល់កម្រិត",
    "owner.pNoPromos": "មិនទាន់មានកូដបញ្ចុះតម្លៃទេ។",
    "owner.pDeleteBlocked": "កូដដែលបានប្រើមិនអាចលុបបានទេ — សូមបិទជំនួស។",
    "confirm.payNowCta": "ទទួលយក QR សម្រាប់ទូទាត់",
    "auth.membership": "សមាជិកភាព / រង្វាន់",
    "owner.stockTab": "ស្តុក",
    "owner.stockHint": "កំណត់ចំនួនស្តុករបស់អ្នកសម្រាប់ផលិតផលនីមួយៗ។ កាតផលិតផល និងកាបូបនឹងបង្ហាញវាភាគៃ។",
    "confirm.track": "តាមដានការបញ្ជាទិញរបស់ខ្ញុំ",
    "confirm.earned": "អ្នកទទួលបាន",
    "confirm.copy": "ចម្លងលេខកូដ",
    "confirm.continue": "បន្តទិញទំនិញ",
    "toast.copied": "បានចម្លង ✓",
    "toast.bye": "បានចាកចេញ។ ជួបគ្នាឆាប់ៗ!",
    "toast.blog": "ប្លុកមកដល់ឆាប់ៗ",
    "addon.add": "បន្ថែម",
    "opt.knee": "គាំងជង្គង់",
    "opt.bag": "ថង់ដៃ",
    "opt.kneeShort": "គាំងជង្គង់",
    "opt.bagShort": "ថង់ដៃ",
    "cart.color": "ពណ៌",
    "track.title": "តាមដានការបញ្ជាទិញ",
    "track.placeholder": "លេខកូដ ឧ. PMK-A7K29",
    "track.button": "តាមដាន",
    "track.notFound": "រកមិនឃើញការបញ្ជាទិញ — សូមពិនិត្យលេខកូដឡើងវិញ។",
    "track.phoneMatch": "លេខទូរស័ព្ទមិនត្រូវនឹងការបញ្ជាទិញនេះទេ។",
    "track.phonePlaceholder": "លេខទូរស័ព្ទដែលបានប្រើពេលបញ្ជាទិញ",
    "track.awaiting": "ការទូទាត់កំពុងរង់ចាំ — PaMak នឹងបញ្ជាក់ការផ្ទេរប្រាក់ ABA របស់អ្នកឆាប់ៗ។",
    "track.hint": "រាល់ការបញ្ជាទិញមានលេខកូដពិសេសដូច PMK-A7K29។ តាមដានដោយលេខកូដ + លេខទូរស័ព្ទ។",
    "track.items": "មុខទំនិញ",
    "track.payment": "ការទូទាត់",
    "track.step.received": "បានទទួលការបញ្ជាទិញ",
    "track.step.pending": "កំពុងរង់ចាំការទូទាត់",
    "track.step.confirmed": "ការទូទាត់ត្រូវបានបញ្ជាក់",
    "track.step.preparing": "កំពុងរៀបចំការបញ្ជាទិញ",
    "track.step.shipped": "បានដឹកជញ្ជូន",
    "track.step.out": "កំពុងផ្តល់សេវាដឹកជញ្ជូន",
    "track.step.delivered": "បានទទួល",
    "faq.title": "ជំនួយ PaMak",
    "faq.placeholder": "សួរអំពីផលិតផល ដឹកជញ្ជូន ការទូទាត់…",
    "faq.hello": "សួស្តី! ខ្ញុំអាចជួយអំពីផលិតផល ការដឹកជញ្ជូន ការទូទាត់ និងការតាមដាន។",
    "footer.track": "តាមដានការបញ្ជាទិញ",
    "orders.title": "ការបញ្ជាទិញរបស់ខ្ញុំ",
    "orders.empty": "មិនមានការបញ្ជាទិញទេ — ចាប់ផ្តើមការបញ្ជាទិញដំបូងរបស់អ្នក!",
    "status.received": "ការបញ្ជាទិញថ្មី",
    "status.processing": "កំពុងដំណើរការ",
    "status.preparing": "កំពុងរៀបចំ",
    "status.ready_for_delivery": "រួចរាល់សម្រាប់ការដឹកជញ្ជូន",
    "status.shipped": "កំពុងដឹកជញ្ជូន",
    "status.out_for_delivery": "កំពុងដឹកជញ្ជូន",
    "status.delivered": "បានបញ្ចប់",
    "status.cancelled": "បានបោះបង់",
    "owner.confirmPay": "បញ្ជាក់ការទូទាត់",
    "owner.flowProcess": "ចាប់ផ្តើមដំណើរការ",
    "owner.flowPrepare": "ចាប់ផ្តើមរៀបចំ",
    "owner.flowReady": "សម្គាល់រួចរាល់ដឹកជញ្ជូន",
    "owner.flowShip": "សម្គាល់បានដឹកជញ្ជូន",
    "owner.flowComplete": "សម្គាល់បានបញ្ចប់",
    "cart.total": "សរុប",
    "cart.checkout": "ទូទាត់",

    "payment.pending": "កំពុងរង់ចាំការទូទាត់",
    "payment.submitted": "បានដាក់ស្នើការទូទាត់ — រង់ចាំការបញ្ជាក់",
    "payment.contact_required": "ត្រូវការទំនាក់ទំនង",
    "payment.confirmed": "បានទូទាត់ / បានបញ្ជាក់",
    "confirm.paywayRedirect": "អ្នកនឹងត្រូវបញ្ជូនទៅកាន់ ABA PayWay ដើម្បីបញ្ចប់ការទូទាត់ដោយសុវត្ថិភាព។ បន្ទាប់ពីទូទាត់រួច សូមត្រឡប់មកកាន់ PaMak ដើម្បីបញ្ចប់ការបញ្ជាទិញរបស់អ្នក។",
    "confirm.payWithPayway": "ទូទាត់ជាមួយ ABA PAYWAY",
    "confirm.paywayOpened": "បានបើក ABA PayWay ក្នុងផ្ទាំងថ្មី — បន្ទាប់ពីទូទាត់រួច សូមចុចប៊ូតុងខាងក្រោម។",
    "confirm.qrScanInstruction": "សូមស្កេន QR នេះដោយប្រើ ABA Mobile ឬកម្មវិធីធនាគារដែលគាំទ្រ KHQR ដើម្បីបង់ប្រាក់។",
    "checkout.telegramPhone": "លេខទូរស័ព្ទ Telegram",
    "checkout.telegramPhonePlaceholder": "+855 XX XXX XXX",
    "checkout.telegramPhoneNote": "សូមបញ្ចូលលេខទូរស័ព្ទដែលត្រូវជាមួយគណនី Telegram របស់អ្នក។ ក្រុមការងារ PaMak នឹងទំនាក់ទំនងមករកអ្នក ដើម្បីរៀបចំនិងផ្ទៀងផ្ទាត់ការទូទាត់។",
    "checkout.telegramPhoneError": "សូមបញ្ចូលលេខទូរស័ព្ទដែលមានលេខកូដប្រទេសត្រឹមត្រូវ ឧ. +855 XX XXX XXX",
    "name.pin": "កន្លាស់",
    "name.strap": "ខ្សែរឹត1គូ",
    "owner.date.all": "គ្រប់ពេល",
    "owner.date.today": "ថ្ងៃនេះ",
    "owner.date.yesterday": "ម្សិលមិញ",
    "owner.date.7d": "៧ ថ្ងៃចុងក្រោយ",
    "owner.date.30d": "៣០ ថ្ងៃចុងក្រោយ",
    "owner.date.day": "ជ្រើសរើសថ្ងៃ",
    "owner.date.range": "ជ្រើសរើសចន្លោះ",
    "owner.cardTotal": "ការបញ្ជាទិញសរុប",
    "owner.cardConfirmNeeded": "ត្រូវការបញ្ជាក់ការទូទាត់",
    "owner.cardContact": "ត្រូវការទំនាក់ទំនង",
    "owner.cardAwaiting": "កំពុងរង់ចាំការទូទាត់",
    "owner.cardReadyProcess": "រួចរាល់ដើម្បីដំណើរការ",
    "owner.cardPreparing": "កំពុងរៀបចំ",
    "owner.cardReadyDelivery": "រួចរាល់ដឹកជញ្ជូន",
    "owner.cardCompleted": "បានបញ្ចប់",
    "owner.cardCancelled": "បានបោះបង់",
    "owner.cardLowStock": "ផលិតផលស្តុកតិច",
    "owner.ordersInPeriod": "ការបញ្ជាទិញក្នុងរយៈពេលដែលបានជ្រើសរើស",
    "owner.noOrdersMatch": "គ្មានការបញ្ជាទិញដែលត្រូវគ្នានឹងតម្រងទាំងនេះទេ។",
    "owner.searchOrders": "ស្វែងរកលេខបញ្ជាទិញ ឈ្មោះ លេខទូរស័ព្ទ ឬលេខ Telegram…",
    "owner.filterMethod": "វិធីទូទាត់",
    "owner.filterPayStatus": "ស្ថានភាពការទូទាត់",
    "owner.filterOrderStatus": "ស្ថានភាពការបញ្ជាទិញ",
    "owner.all": "ទាំងអស់",
    "owner.payOther": "វិធីទូទាត់ផ្សេងៗ",
    "owner.telegramPhone": "លេខ Telegram",
    "owner.promo": "កូដបញ្ចុះតម្លៃ",
    "owner.subtotal": "សរុបរង",
    "owner.customer": "អតិថិជន",
    "owner.address": "អាសយដ្ឋាន",
    "owner.cancelOrder": "បោះបង់ការបញ្ជាទិញ",
    "owner.cancelConfirmTitle": "បោះបង់ការបញ្ជាទិញនេះ?",
    "owner.cancelConfirmBody": "ការបញ្ជាទិញ {code} នឹងត្រូវសម្គាល់ជាបានបោះបង់។ ស្តុកមិនរងផលប៉ះពាល់ទេ។ តើអ្នកប្រាកដទេ?",
    "owner.lowStockWarn": "⚠ ស្តុកតិច",
    "owner.threshold": "កម្រិតការព្រមានស្តុកតិច",
    "owner.stockAdded": "ស្តុកបានបន្ថែម",
    "owner.stockDeducted": "ស្តុកបានដក",
    "owner.history": "ប្រវត្តិស្តុក",
    "owner.noHistory": "មិនមានព្រឹត្តិការណ៍ស្តុកទេ។",
    "owner.histOrder": "លក់",
    "owner.histManual": "កែតម្រូវដោយដៃ",
    "owner.marketingTab": "ផ្សព្វផ្សាយ",
    "owner.marketingHint": "តែអតិថិជនដែលបានយល់ព្រមទទួលអ៊ីមែលផ្សព្វផ្សាយតែប៉ុណ្ណោះ នឹងទទួលបាន។ អ៊ីមែលទាំងអស់មានតំណឈប់ជាវិញ។",
    "owner.marketingNotConfigured": "ការផ្ញើអ៊ីមែលផ្សព្វផ្សាយត្រូវការ domain pamakofficial.shop ដែលបានផ្ទៀងផ្ទាត់ជាមុនសិន។ អ៊ីមែលការបញ្ជាទិញមិនរងផលប៉ះពាល់ទេ។",
    "owner.marketingSubject": "ប្រធានបទ",
    "owner.marketingBody": "សារ",
    "owner.marketingSend": "ផ្ញើទៅអតិថិជនដែលព្រមទទួល",
    "owner.marketingHistory": "ការផ្សព្វផ្សាយមុនៗ",
    "owner.marketingDelivered": "បានទៅដល់",
    "owner.marketingFailed": "បរាជ័យ",
    "owner.marketingSent": "បានផ្ញើអ៊ីមែលផ្សព្វផ្សាយទៅ {n} អតិថិជន ✓",
    "owner.emailVerified": "អ៊ីមែលផ្ទៀងផ្ទាត់",
    "owner.membershipStatus": "សមាជិកភាព",
    "owner.marketingConsent": "ការយល់ព្រមទទួលព័ត៌មាន",
    "owner.lastEmail": "អ៊ីមែលចុងក្រោយ",
    "owner.emailSent": "បានផ្ញើ",
    "owner.emailFailed": "បរាជ័យ",
    "owner.yes": "មាន",
    "owner.no": "គ្មាន",

    "toast.added": "បានបញ្ចូលទៅកន្ត្រក ✓",
    "toast.emptyCart": "កន្ត្រករបស់អ្នកគឺទំនេរ។",
    "toast.orderOk": "បង្កើតការបញ្ជាទិញដោយជោគជ័យ ✓",
    "toast.orderFail": "បញ្ជាការទិញមិនបានសម្រេច។ សូមព្យាយាមម្តងទៀត។",
    "toast.memberOk": "សូមស្វាគមន៍មកកាន់ក្រុម PaMak ♡",
    "toast.memberEmpty": "សូមបញ្ចូលលេខទូរស័ព្ទ ឬអ៊ីមែល។",
    "toast.soon": "មកដល់ឆាប់ៗ",
    "toast.language": "បានប្តូរភាសារួចរាល់",

    "checkout.eyebrow": "ការទូទាត់ PAMAK",
    "checkout.title": "ព័ត៌មានដឹកជញ្ជូន",
    "checkout.name": "ឈ្មោះពេញ *",
    "checkout.phone": "លេខទូរស័ព្ទ *",
    "checkout.province": "ខេត្ត / ក្រុង *",
    "checkout.district": "ស្រុក / ខណ្ឌ *",
    "checkout.commune": "ឃុំ / សង្កាត់",
    "checkout.village": "ភូមិ / ផ្លូវ / លេខផ្ទះ",
    "checkout.deliveryDetails": "លម្អិតការដឹកជញ្ជូន",
    "checkout.remark": "កំណត់សម្គាល់",
    "checkout.payment": "វិធីបង់ប្រាក់",
    "checkout.aba": "ABA / KHQR",
    "checkout.other": "វិធីបង់ប្រាក់ផ្សេងទៀត",
    "checkout.note": "បន្ទាប់ពីដាក់បញ្ជាទិញ តំណភ្ជាប់ទូទាត់ ABA PayWay / KHQR នឹងបើក។ PaMak នឹងបញ្ជាក់ការទូទាត់របស់អ្នកឆាប់ៗបន្ទាប់ពីអ្នកបង់។",
    "checkout.error": "សូមបំពេញព័ត៌មានដឹកជញ្ជូនដែលចាំបាច់ទាំងអស់។",
    "checkout.place": "បញ្ជាការទិញ",
    "checkout.summary": "ការបញ្ជាទិញរបស់អ្នក",

    "footer.shop": "ទំនិញ",
    "footer.about": "អំពី PaMak",
    "footer.help": "ជំនួយ",
    "footer.follow": "តាមដានយើង",
    "footer.allProducts": "ផលិតផលទាំងអស់",
    "footer.knee": "ខ្សែរឹតជង្គង់",
    "footer.bag": "កាបូបក្រវាត់ចង្កេះ",
    "footer.soon": "មកដល់ឆាប់ៗ",
    "footer.ourStory": "រឿងរបស់យើង",
    "footer.active": "ជីវិតសកម្ម",
    "footer.blog": "ប្លុក",
    "footer.faq": "សំណួរញឹកញាប់",
    "footer.delivery": "ការដឹកជញ្ជូន",
    "footer.returns": "ការប្រគល់មុខទំនិញ",
    "footer.contact": "ទំនាក់ទំនង",
    "footer.copyright": "© 2026 PaMak។ រក្សាសិទ្ធិគ្រប់បែបយ៉ាង។",
    "footer.tagline": "សកម្ម។ ជិតគ្នា។ PaMak។",
  },
};

export const accentText = (text) => {
  if (!text) return [];
  return text.split(/\*([^*]+)\*/).map((part, i) => ({ text: part, accent: i % 2 === 1 }));
};
